import ListPage from "../../pages/ListPage";
import { useBranchesServices } from "./hook";
import AddButton from "../../components/molecules/AddButton/AddButton";
import { useLocale } from "../../locales";
import ModalComponent from "../../components/organisms/ModalComponent";
import ConfirmationModal from "../../components/organisms/Confirmation Modal";
import AppDataForm from "../../components/organisms/AppDataForm/AppDataForm";
import Loader from "../../components/atoms/Loader";

export interface services {}

const BranchesServices = ({}: services) => {
  const {
    appDataLoading,
    dropdowns,
    handleOpenAddModal,
    handleCloseAddModal,
    addModal,
    onSubmit,
    control,
    handleSubmit,
    loading,
    deleteModal,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    deleteLoading,
    onConfirmDelete,
    handleOpenEditModal,
    handleCloseEditModal,
    editModal,
    editLoading,
    onSubmitEdit,
    errors,
    branches
  } = useBranchesServices();
  const { localeButtons, localeLabels, localeTitles, localePlaceholders } =
    useLocale();

  if (appDataLoading) {
    return (
      <div className="flex h-[80%] w-full justify-center">
        <Loader />
      </div>
    );
  }
  return (
    <>
      <div className="pt-10 pr-10 flex justify-end">
        <AddButton
          text={localeButtons.BUTTON_ADD_BRANCHES}
          onClick={handleOpenAddModal}
        />
      </div>
      <ListPage
        onClickDelete={handleOpenDeleteModal}
        onClickEdit={handleOpenEditModal}
        type={"Branches"}
        list={branches}
        // hasMore={hasMore}
        totalUsers={branches?.length}
        loading={appDataLoading}
      />

      {/* Add Form */}
      <ModalComponent show={addModal}>
        <AppDataForm
          handleSubmit={handleSubmit}
          control={control}
          type="Branches"
          errors={errors}
          onSubmit={onSubmit}
          loading={loading}
          onHide={handleCloseAddModal}
          title={localeTitles.TITLE_PLEASE_ADD_BRANCH}
          primaryBtnText={localeButtons.BUTTON_ADD_BRANCH}
          placeholder={localePlaceholders.PLACEHOLDER_ADD_BRANCH_NAME}
          label1={localeLabels.LABEL_BRANCH_NAME_ENGLISH}
          label2={localeLabels.LABEL_BRANCH_NAME_DUTCH}
        />
      </ModalComponent>
      {/* Add Form */}

      {/* Edit Form */}
      <ModalComponent show={editModal}>
        <AppDataForm
          handleSubmit={handleSubmit}
          control={control}
          type="Branches"
          errors={errors}
          onSubmit={onSubmitEdit}
          loading={editLoading}
          onHide={handleCloseEditModal}
          title={localeTitles.TITLE_EDIT_BRANCH}
          primaryBtnText={localeButtons.BUTTON_EDIT}
          placeholder={localePlaceholders.PLACEHOLDER_ADD_BRANCH_NAME}
          label1={localeLabels.LABEL_BRANCH_NAME_ENGLISH}
          label2={localeLabels.LABEL_BRANCH_NAME_DUTCH}
        />
      </ModalComponent>
      {/* Edit Form */}

      {/* Delete Branch */}
      <ConfirmationModal
        show={deleteModal}
        title={localeLabels.LABEL_ARE_YOU_SURE_YOU_WANT_TO_DELETE_BRANCH}
        onHide={handleCloseDeleteModal}
        onConfirm={onConfirmDelete}
        loading={deleteLoading}
      />
      {/* Delete Branch */}
    </>
  );
};

export default BranchesServices;
